export const reactSelectDark = {
  control: (base, state) => ({
    ...base,
    // The deep green field and the yellow accent on focus — as the other fields.
    backgroundColor: '#072019',
    borderColor: state.isFocused ? '#f5b94a' : 'rgba(245, 185, 74, 0.16)',
    // minHeight: '32px',
    height: '42px',
    // fontSize: '0.85rem',
    color: '#f1f1f1',
    boxShadow: 'none',
    '&:hover': {
      borderColor: state.isFocused ? '#f5b94a' : 'rgba(245, 185, 74, 0.35)'
    }
  }),

  menu: (base) => ({
    ...base,
    // The raised dark surface.
    backgroundColor: '#071a15',
    color: '#f1f1f1',
    borderRadius: 6,
    marginTop: 4,
    zIndex: 9999
  }),

  option: (base, { isFocused, isSelected }) => ({
    ...base,
    // Hover: see-through yellow; selected: a step stronger, in yellow text.
    backgroundColor: isSelected ? 'rgba(245, 185, 74, 0.15)' : isFocused ? 'rgba(245, 185, 74, 0.1)' : '#071a15',
    color: isSelected ? '#f5b94a' : '#f1f1f1',
    fontWeight: isSelected ? 600 : base.fontWeight,
    cursor: 'pointer',
    fontSize: '0.85rem'
  }),

  singleValue: (base) => ({
    ...base,
    color: '#f1f1f1'
  }),

  placeholder: (base) => ({
    ...base,
    color: '#9ca3af' // muted light
  }),

  valueContainer: (base) => ({
    ...base,
    height: '32px',
    padding: '0 6px'
  }),

  indicatorsContainer: (base) => ({
    ...base,
    height: '32px'
  })
};
